// extracted by mini-css-extract-plugin
export var externalLink = "_a9-0";
export var internalLinkLabel = "_a9-1";